import { useEffect, useState } from "react"
import { Box, Typography, Avatar, Paper } from "@mui/material"
import { useApiService } from "../hooks/Api/useApiService"
import styles from "./SimilarUsers.module.css"
import useTranslationSharie from "../hooks/Language/useTranslation"
import UserSection from "../Marketplace/UserSection/UserSection"

const SimilarUsers = ({ user_name }) => {
  const [similarUsers, setSimilarUsers] = useState([])
  const { postData } = useApiService()
  const t = useTranslationSharie()

  useEffect(() => {
    postData("users/getSimilarUsers", {
      user_name: user_name,
    })
      .then((data) => {
        if (data?.similar_users) {
          // Create a Set to track unique `user_name`s
          const seenUserNames = new Set()
          const uniqueUsers = data.similar_users.filter((user) => {
            if (!seenUserNames.has(user[0].user_name)) {
              seenUserNames.add(user[0].user_name)
              return true // Keep this user
            }
            return false // Skip duplicate user_name
          })
          setSimilarUsers(uniqueUsers)
        } else {
          setSimilarUsers([])
        }
      })
      .catch((error) => console.error("Error fetching similar users:", error))
  }, [user_name])

  return (
    <Box className={styles.similar_users_container}>
      <Typography variant='h6' gutterBottom>
        {t("People Like Me")}
      </Typography>
      {similarUsers.length > 0 ? (
        similarUsers.map((user, index) => <UserSection user={user[0]} key={index} />)
      ) : (
        <Typography variant='body2'>{t("No similar users found.")}</Typography>
      )}
    </Box>
  )
}

export default SimilarUsers
